/* FAQ accordion: single-open, first item open by default */
(function () {
  document.querySelectorAll('.faq-section .faq-list').forEach(function (list) {
    var items = list.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      var button = item.querySelector('.faq-q');
      var panel = item.querySelector('.faq-a');

      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');

        items.forEach(function (other) {
          other.classList.remove('open');
          other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          other.querySelector('.faq-a').setAttribute('aria-hidden', 'true');
        });

        if (!wasOpen) {
          item.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('aria-hidden');
        }
      });
    });
  });
})();